import { QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 2,
			staleTime: 10 * 60 * 1000,	// 10 minutes
			gcTime: 5 * 60 * 1000,		// 5 minutes
			refetchOnWindowFocus: false,
		},
	},
})
